var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import DialogMui from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
export function Modal(_a) {
    var _b, _c;
    var children = _a.children, isOpen = _a.isOpen, _d = _a.maxWidth, maxWidth = _d === void 0 ? 'md' : _d, closeModal = _a.closeModal, rest = __rest(_a, ["children", "isOpen", "maxWidth", "closeModal"]);
    var handleOnBackdropClick = function (reason) {
        if ((reason === 'backdropClick' || reason === 'escapeKeyDown') && closeModal) {
            closeModal();
        }
    };
    return (_jsx(DialogMui, __assign({}, rest, { slotProps: {
            paper: __assign(__assign({}, (typeof ((_b = rest.slotProps) === null || _b === void 0 ? void 0 : _b.paper) === 'object' ? rest.slotProps.paper : {})), { sx: __assign({ borderRadius: '10px', width: 'calc(100% - 32px)', margin: 0 }, (typeof ((_c = rest.slotProps) === null || _c === void 0 ? void 0 : _c.paper) === 'object' ? rest.slotProps.paper.sx : {})) }),
        }, "aria-describedby": "modal-modal-description", "aria-labelledby": "modal-modal-title", fullWidth: true, maxWidth: maxWidth, open: isOpen, onClose: function (_, reason) { return handleOnBackdropClick(reason); }, children: _jsx(DialogContent, { sx: { p: 0 }, children: children }) })));
}
